import { REQUEST_URL } from "../constants";
import { RequestFileUtil, RequestUtil } from "../utils";
import { DocumentQueryModel } from "../models"

export const DocumentService = {
  getFileByCategory,
  uploadFile,
  deleteFile,
  updateStatus
};

async function getFileByCategory(query: DocumentQueryModel) {
  const url = REQUEST_URL.GET_FILE_BY_CATEGORY;

  return RequestUtil.get({ url, query: query });
}

async function uploadFile(formData: FormData) {
  const url = REQUEST_URL.UPLOAD_FILE;

  return RequestFileUtil.post({ url, data: formData });
}

async function deleteFile(fileId: string) {
  const url = REQUEST_URL.DELETE_FILE.replace("{FILE_ID}", fileId);

  return RequestUtil.delete({ url });
}

async function updateStatus(fileId: string, data: { status: string }) {
  const url = REQUEST_URL.UPDATE_FILE_STATUS.replace("{FILE_ID}", fileId);

  return RequestUtil.put({ url, data });
}
